import { Sun, Moon, Palette } from 'lucide-react';
import { useTheme } from '@/lib/theme';
import { useState, useRef, useEffect } from 'react';

export function ThemeToggle() {
  const { mode, themeName, toggleMode, setThemeName } = useTheme();
  return (
    <button
      onClick={toggleMode}
      className="theme-toggle"
      title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label="Toggle theme"
    >
      {mode === 'dark' ? (
        <Sun className="size-4" />
      ) : (
        <Moon className="size-4" />
      )}
    </button>
  );
}

export function ThemeNameToggle() {
  const { themeName, setThemeName } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="theme-toggle"
        title="Switch theme"
        aria-label="Switch theme"
      >
        <Palette className="size-4" />
      </button>
      {open && (
        <div className="absolute bottom-full left-0 mb-1.5 bg-card border border-border shadow-md min-w-[120px] py-1 z-50">
          <button
            onClick={() => { setThemeName('moonshot'); setOpen(false); }}
            className={`w-full text-left px-3 py-1.5 text-xs font-medium hover:bg-accent transition-colors flex items-center gap-2 ${
              themeName === 'moonshot' ? 'text-primary' : 'text-foreground'
            }`}
          >
            <span className="flex gap-0.5">
              <span className="w-2 h-2" style={{ background: '#457B9D' }} />
              <span className="w-2 h-2" style={{ background: '#2A9D8F' }} />
              <span className="w-2 h-2" style={{ background: '#F4A261' }} />
              <span className="w-2 h-2" style={{ background: '#E63946' }} />
            </span>
            Moonshot
          </button>
          <button
            onClick={() => { setThemeName('classic'); setOpen(false); }}
            className={`w-full text-left px-3 py-1.5 text-xs font-medium hover:bg-accent transition-colors flex items-center gap-2 ${
              themeName === 'classic' ? 'text-primary' : 'text-foreground'
            }`}
          >
            <span className="flex gap-0.5">
              <span className="w-2 h-2 rounded-full" style={{ background: '#3b6ef5' }} />
            </span>
            Classic
          </button>
        </div>
      )}
    </div>
  );
}
